import QRCode from 'qrcode.react'
import { Popover } from 'antd'

export default props => {
  const content = (
    <div className='text-center'>
      <QRCode value={props.url} />

      <div className='text-secondary'>扫一扫分享</div>
    </div>
  )

  return (
    <Popover content={content}>
      {props.children}
    </Popover>
  )
}
